import { setRegion } from './helpers';
import { RESET_REQUESTED_REGION } from '../../actions-types';

export default Object.freeze({
    /**
     * Set the region
     * @param {string} zip
     * @return {Promise}
     */
    setRegion({ zip }) {
        return setRegion({ zip });
    },
    reset() {
        return { type: RESET_REQUESTED_REGION };
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/region/actions.js